import './header.css';
import Horizontallogo from '../images/Horizontallogo.jpg'
import React, { useState, useEffect  } from 'react';
import { useUserContext } from './UserContext.js';
import LoginSignupModal from './loginsignupmodal.js';
import PageMenu from './pagemenu.js';
import NotificationCenter from './NotificationCenter.js';
import HeaderMenu from './HeaderMenu.js';




const Header = () => {
  const { user } = useUserContext();
  const [showModal, setShowModal] = useState(false);

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  const getUserInitials = (user) => {
    // Use the initials field from the user profile if available
    if (user?.initials && user.initials.trim()) {
      return user.initials.toUpperCase();
    }
    
    // Fallback to generating initials from username if no initials field
    const username = user?.username || '';
    if (!username || typeof username !== 'string') return '';
    
    const words = username.trim().split(/\s+/).filter(word => word.length > 0);
    
    if (words.length >= 2) {
      return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
    } else if (words.length === 1) {
      return words[0].charAt(0).toUpperCase();
    }
    
    return username.charAt(0).toUpperCase();
  };
  

  return (
    <div className="header">
        <img className='imgHorizontallogo' src={Horizontallogo} alt='Horizontallogo' />
        
        {/* Desktop PageMenu */}
        <PageMenu className="desktop-pagemenu" />
        
        <nav className="header-nav">
        {user ? (
          <>
            <NotificationCenter />
            <HeaderMenu />
            <button className="header-user-info" onClick={toggleModal} title={user.username} aria-label={`Account: ${user.username}`}>
              <span className="header-avatar">{getUserInitials(user)}</span>
              <span className="desktop-username">{user.username}</span>
            </button>
          </>
        ) : (
          <button className="header-login-btn" onClick={toggleModal}>
            Log In
          </button>
        )}
      </nav>
      
      <LoginSignupModal showModal={showModal} toggleModal={toggleModal} />
    </div>
  );
}

export default Header;
